(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["headernew"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class HeaderSaavedra extends HTMLElement {
      constructor() {
        super();
        this.scrolled = false;
        this.menuAbierto = false;
        this.umbralScroll = 40;
      }

      connectedCallback() {
        this.toggle = this.querySelector('.seccion-header-saavedra__toggle-mobile');
        this.menuMobile = this.querySelector('.seccion-header-saavedra__menu-mobile');
        this.enlacesMobile = this.querySelectorAll('.seccion-header-saavedra__menu-mobile-enlace');

        this.onScroll = this.onScroll.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.cerrarMenu = this.cerrarMenu.bind(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.toggle) {
          this.toggle.addEventListener('click', this.onToggle);
        }
        this.enlacesMobile.forEach((enlace) => {
          enlace.addEventListener('click', this.cerrarMenu);
        });

        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.toggle) {
          this.toggle.removeEventListener('click', this.onToggle);
        }
        this.enlacesMobile.forEach((enlace) => {
          enlace.removeEventListener('click', this.cerrarMenu);
        });
      }

      onScroll() {
        const debeEstarScrolled = window.scrollY > this.umbralScroll;
        if (debeEstarScrolled !== this.scrolled) {
          this.scrolled = debeEstarScrolled;
          this.setAttribute('data-scrolled', this.scrolled ? 'true' : 'false');
        }
      }

      onToggle() {
        this.menuAbierto = !this.menuAbierto;
        this.toggle.setAttribute('aria-expanded', this.menuAbierto ? 'true' : 'false');
        if (this.menuMobile) {
          this.menuMobile.setAttribute('aria-hidden', this.menuAbierto ? 'false' : 'true');
        }
        this.setAttribute('data-menu-abierto', this.menuAbierto ? 'true' : 'false');
      }

      cerrarMenu() {
        if (!this.menuAbierto) return;
        this.menuAbierto = false;
        if (this.toggle) {
          this.toggle.setAttribute('aria-expanded', 'false');
        }
        if (this.menuMobile) {
          this.menuMobile.setAttribute('aria-hidden', 'true');
        }
        this.setAttribute('data-menu-abierto', 'false');
      }
    }

    if (!customElements.get('header-saavedra')) {
      customElements.define('header-saavedra', HeaderSaavedra);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-bus"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class SliderSeccionesSaavedra extends HTMLElement {
      constructor() {
        super();
        this.indiceActual = 0;
        this.intervaloAutoplay = null;
        this.totalSlides = 0;
        this.enPausa = false;
      }

      connectedCallback() {
        this.slides = this.querySelectorAll('.seccion-slider-saavedra__slide');
        this.indicadores = this.querySelectorAll('.seccion-slider-saavedra__indicador');
        this.flechaAnterior = this.querySelector('.seccion-slider-saavedra__flecha--anterior');
        this.flechaSiguiente = this.querySelector('.seccion-slider-saavedra__flecha--siguiente');
        this.contenedor = this.querySelector('.seccion-slider-saavedra__contenedor');

        this.totalSlides = this.slides.length;
        if (this.totalSlides <= 1) return;

        this.autoplay = this.getAttribute('data-autoplay') === 'true';
        const tiempoSegundos = parseFloat(this.getAttribute('data-tiempo-autoplay')) || 5.5;
        this.tiempoAutoplay = tiempoSegundos * 1000;

        this.onClickAnterior = this.onClickAnterior.bind(this);
        this.onClickSiguiente = this.onClickSiguiente.bind(this);
        this.onClickIndicador = this.onClickIndicador.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);

        if (this.flechaAnterior) {
          this.flechaAnterior.addEventListener('click', this.onClickAnterior);
        }
        if (this.flechaSiguiente) {
          this.flechaSiguiente.addEventListener('click', this.onClickSiguiente);
        }
        this.indicadores.forEach((indicador) => {
          indicador.addEventListener('click', this.onClickIndicador);
        });

        if (this.contenedor) {
          this.contenedor.addEventListener('mouseenter', this.onMouseEnter);
          this.contenedor.addEventListener('mouseleave', this.onMouseLeave);
        }

        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.iniciarAutoplay();
        this.iniciarTouch();
      }

      disconnectedCallback() {
        this.detenerAutoplay();
        if (this.flechaAnterior) this.flechaAnterior.removeEventListener('click', this.onClickAnterior);
        if (this.flechaSiguiente) this.flechaSiguiente.removeEventListener('click', this.onClickSiguiente);
        this.indicadores.forEach((indicador) => {
          indicador.removeEventListener('click', this.onClickIndicador);
        });
        if (this.contenedor) {
          this.contenedor.removeEventListener('mouseenter', this.onMouseEnter);
          this.contenedor.removeEventListener('mouseleave', this.onMouseLeave);
        }
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      irASlide(indice) {
        if (indice === this.indiceActual) return;
        if (indice < 0) indice = this.totalSlides - 1;
        if (indice >= this.totalSlides) indice = 0;

        this.slides.forEach((slide, i) => {
          if (i === indice) {
            slide.classList.add('seccion-slider-saavedra__slide--activo');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.classList.remove('seccion-slider-saavedra__slide--activo');
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        this.indicadores.forEach((indicador, i) => {
          if (i === indice) {
            indicador.classList.add('seccion-slider-saavedra__indicador--activo');
          } else {
            indicador.classList.remove('seccion-slider-saavedra__indicador--activo');
          }
        });

        this.indiceActual = indice;
      }

      onClickAnterior() {
        this.irASlide(this.indiceActual - 1);
        this.reiniciarAutoplay();
      }

      onClickSiguiente() {
        this.irASlide(this.indiceActual + 1);
        this.reiniciarAutoplay();
      }

      onClickIndicador(evento) {
        const indice = parseInt(evento.currentTarget.getAttribute('data-ir-a'), 10);
        if (!isNaN(indice)) {
          this.irASlide(indice);
          this.reiniciarAutoplay();
        }
      }

      iniciarAutoplay() {
        if (!this.autoplay || this.totalSlides <= 1) return;
        this.detenerAutoplay();
        this.intervaloAutoplay = setInterval(() => {
          if (!this.enPausa) {
            this.irASlide(this.indiceActual + 1);
          }
        }, this.tiempoAutoplay);
      }

      detenerAutoplay() {
        if (this.intervaloAutoplay) {
          clearInterval(this.intervaloAutoplay);
          this.intervaloAutoplay = null;
        }
      }

      reiniciarAutoplay() {
        if (this.autoplay) {
          this.iniciarAutoplay();
        }
      }

      onMouseEnter() {
        this.enPausa = true;
      }

      onMouseLeave() {
        this.enPausa = false;
      }

      onVisibilityChange() {
        this.enPausa = document.hidden;
      }

      iniciarTouch() {
        let inicioX = 0;
        let finX = 0;
        const umbral = 50;

        this.contenedor.addEventListener('touchstart', (e) => {
          inicioX = e.changedTouches[0].screenX;
        }, { passive: true });

        this.contenedor.addEventListener('touchend', (e) => {
          finX = e.changedTouches[0].screenX;
          const diferencia = finX - inicioX;
          if (Math.abs(diferencia) >= umbral) {
            if (diferencia < 0) {
              this.irASlide(this.indiceActual + 1);
            } else {
              this.irASlide(this.indiceActual - 1);
            }
            this.reiniciarAutoplay();
          }
        }, { passive: true });
      }
    }

    if (!customElements.get('slider-secciones-saavedra')) {
      customElements.define('slider-secciones-saavedra', SliderSeccionesSaavedra);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
